<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="showCreateRouter()" class="btn-in-line">create router</zm-button>
            <zm-button size="small" @click="showAll()" type="primary" class="btn-in-line">show all router</zm-button>
            <zm-input size="small" placeholder="router name" v-model.trim="search" class="search-input">
                <zm-button size="small" slot="append" icon="zm-icon-search" @click="searchByName()"></zm-button>
            </zm-input>
        </zm-row>
        <div class="table-container">
            <zm-table :data="tableData.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)"
            v-loading="loading" :stripe="true">
                <zm-table-column prop="name" label="name" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="id" label="id" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="zone" label="zone" align="center">
                </zm-table-column>
                <zm-table-column prop="health" label="health" align="center">
                    <template slot-scope="scope">
                        <i v-if="scope.row.health" class="zm-icon-ok"></i>
                        <i v-else class="zm-icon-close"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="createdTime" label="createdTime" align="center" :formatter="setTime">
                </zm-table-column>
                <zm-table-column prop="active" label="active" align="center">
                    <template slot-scope="scope">
                        <i v-if="scope.row.active" class="zm-icon-ok"></i>
                        <i v-else class="zm-icon-close"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="backup" label="backup" align="center">
                </zm-table-column>
                <zm-table-column prop="sync" label="sync" align="center">
                    <template slot-scope="scope">
                        <i v-if="scope.row.sync" class="zm-icon-ok"></i>
                        <i v-else class="zm-icon-close"></i>
                    </template>
                </zm-table-column>
                <zm-table-column label="operate" width="190px" align="center">
                    <template slot-scope="scope">
                        <!-- <zm-button size="small" class="btn-contain" type="icon" title="edit user" icon="zm-icon-edit" @click="showEditUser(scope.row)"></zm-button> -->
                        <zm-button size="small" class="btn-contain" type="icon" title="enable data center" icon="zm-icon-play" v-if="!scope.row.active" @click="activeDataCenter(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="disable data center" icon="zm-icon-pause" v-if="scope.row.active" @click="activeDataCenter(scope.row)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="paginationChange"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    :page-size="pageable.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.length">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :title="form.title" :visible.sync="dialogFormVisible" label-position="left" :rules="rules" ref="form">
            <zm-form :model="form" label-position="left" :rules="rules" ref="form">
                <zm-form-item label="name" :label-width="formLabelWidth" prop="name">
                    <div slot="label">
                        <tip label="name" id="dc-router-name"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.name"></zm-input>
                </zm-form-item>
                <zm-form-item label="emails" :label-width="formLabelWidth" prop="emails">
                    <div slot="label">
                        <tip label="emails" id="dc-router-emails"></tip>
                    </div>
                    <zm-input size="small" v-model="form.emails" placeholder="san.zhang@zoom.us,si.li@zoom.us,"></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enableAlert">
                        <tip label="enable alert" id="dc-router-enableAlert"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enableReport">
                        <tip label="enable report" id="dc-router-enableReport"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="description" :label-width="formLabelWidth">
                    <div slot="label">
                        <tip label="description" id="dc-router-description"></tip>
                    </div>
                    <zm-input size="small" v-model="form.description"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dialogFormVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getUserList, createUser, updateUser, deleteUser, activeUser } from '../../api/index'
import tip from 'components/ToolTip/index'
export default {
    name: 'router',
    components: { tip },
    data () {
        return {
            list: [],
            loading: false,
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            },
            dialogFormVisible: false,
            form: {
                title: '',
                id: '',
                emails: '',
                role: '',
                enableAlert: false,
                enableReport: false,
                name: '',
                description: ''
            },
            search: '',
            showAllBtn: false,
            formLabelWidth: '100px',
            rules: {
                name: [
                    { required: true, trigger: 'blur' }
                ],
                role: [
                    { required: true, message: 'please enter role', trigger: 'blur' }
                ],
                emails: [
                    { required: true, trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchData()
    },
    computed: {
        tableData () {
            if (this.search) {
                return this.list.filter(data => {
                    return Object.keys(data).some(key => {
                        return String(data[key]).toLowerCase().indexOf(this.search) > -1
                    })
                })
            }
            return this.list
        }
    },
    methods: {
        setTime (row, column, cellValue, index) {
            return cellValue.split('T')[0] + ' ' + cellValue.split('T')[1].split('.')[0]
        },
        fetchData () {
            this.showAllBtn = false
            this.loading = true
            getUserList().then(response => {
                const { content } = response
                this.pageable.total = content.length
                this.list = content
                this.loading = false
            })
        },
        activeDataCenter (row) {
            this.loading = true
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                activeUser(row.id, !row.active).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Change status success!',
                        type: 'success'
                    })
                })
                this.loading = false
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        showApp () {
            this.pageable.pageNumber = 1
            this.fetchData()
        },
        paginationChange () {
            this.fetchData()
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        },
        showEditUser (row) {
            this.form.title = 'Edit User'
            this.dialogFormVisible = true
            this.form.id = row.id
            this.form.name = row.name
            this.form.role = row.role
            this.form.emails = row.emails
            this.form.description = row.description
            this.form.enableAlert = row.enableAlert
            this.form.enableReport = row.enableReport
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    var { id, name, emails, role, enableAlert, enableReport, description } = this.form
                    const data = { name, emails, role, enableAlert, enableReport, description }
                    if (this.form.title === 'Create User') {
                        createUser(data).then(response => {
                            this.pageable.page = 1
                            this.fetchData()
                            this.$message({
                                message: 'Create user success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        })
                    } else if (this.form.title === 'Edit User') {
                        updateUser(id, data).then(response => {
                            this.pageable.page = 1
                            this.fetchData()
                            this.$message({
                                message: 'Edit user success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        })
                    } else {
                        this.$message({
                            message: 'error!',
                            type: 'error'
                        })
                    }
                } else {
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        deleteDataCenter (id) {
            this.$confirm('This will permanently delete the data center. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteUser(id).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Delete data center success!',
                        type: 'success'
                    })
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        }
    }
}
</script>
<style>
.btn-in-line{
    margin: 10px
}
.zm-input-group{
    width: 20%;
}
.input-with-select{
    float: right;
    margin: 10px;
    width: 200px;
}
</style>
